module.exports = __webpack_public_path__ + "american-samoa.svg?95a96e207359b8f2359d08256be64bcc";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/countries/svg/american-samoa.svg
// module id = 89
// module chunks = 10